import { jsxs as t, jsx as a } from "react/jsx-runtime";
import l from "../../utils/classNames.js";
import i from "./ListMenuHeader.js";
const o = ({ menuGroup: e, className: r }) => e.navItems.length ? /* @__PURE__ */ t("ul", { className: `ListMenuGroup ${r}`, children: [
  /* @__PURE__ */ a(i, { ...e }),
  e.navItems.map((s) => /* @__PURE__ */ a("li", { className: l(s.disabled && "disabled", s.isSubItem && "subitem"), children: s.item }, s.key))
] }) : null;
export {
  o as default
};
//# sourceMappingURL=ListMenuGroup.js.map
